import React, { useState, useRef, useLayoutEffect } from 'react';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';
import { getNavbarHeight, getViewportDimensions, keepSpaceTogether } from '../../../../models/Utils';
import LearnMoreLink from '../../../Common/LearnMoreLink/LearnMoreLink';
import { ADAARIARoles } from '../../../../models/ADA';

import './VbnVideo.scss';
import { LearnMoreButton } from '../LearnMore/LearnMoreButton';
import Arrow from '../../../Common/Arrow/Arrow';

const mobileScreenThreshold = 767; // MUST BE IN SYNC WITH CSS

const videoRatio = 16 / 9;
const togetherString = 'V Team';

const VbnVideo = React.forwardRef((props, theRef) => {
  const [ isMobileLayout, setIsMobileLayout ] = useState(false);
  const [ videoDimensions, setVideoDimensions ] = useState({ width: 0, height: 0 });
  const [ rightHeight, setRightHeight ] = useState(null);
  const titleRef = useRef(null);
  const videoWrapperRef = useRef(null);
  const videoTimeout = useSelector(state => state.data.videoFadeTimeout);
  const [ isPlaying, setIsPlaying ] = useState(false);
  const [ hasStarted, setHasStarted ] = useState(false);
  const refIsInView = useRef(false);
  const menuOpened = useSelector(state => state.data.menuOpened);

  const handleResize = () => {
    const width = videoWrapperRef.current.getBoundingClientRect().width;
    const height = width / videoRatio;
    setVideoDimensions({ width, height });

    const onMobile = getViewportDimensions().width <= mobileScreenThreshold;
    setIsMobileLayout(onMobile);
    if (!onMobile) {
      const rh = titleRef.current.getBoundingClientRect().height;
      setRightHeight(`${rh}px`);
    } else {
      setRightHeight('');
    }
  };

  const handleScroll = () => {
    const viewport = getViewportDimensions();
    const rect = videoWrapperRef.current.getBoundingClientRect();
    if (!refIsInView.current && rect.y + rect.height / 2 > 0 && rect.y + rect.height / 2 < viewport.height) {
      refIsInView.current = true;
      loopVideo();
    } else if (refIsInView.current && (rect.y + rect.height < 0 || rect.y > viewport.height)) {
      refIsInView.current = false;
      setIsPlaying(false);
    }
  };

  const loopVideo = () => {
    if (!isPlaying && refIsInView.current) {
      setIsPlaying(true);
    }
  };

  const handleVideoStart = () => {
    setHasStarted(true);
  };

  useLayoutEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);
    document.body.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className="vbn-info-video"
      ref={theRef}
      role={ADAARIARoles.Group}
      tabIndex="-1"
      aria-label={`Section: ${props.data.Title}`}
    >
      <div className="cpvi-grid-container">
        <div className="cpvi-grid-row vbn-iv-title-and-link">
          <div className="vbn-iv-title-wrapper cpvi-grid-col w6" ref={titleRef} role={ADAARIARoles.Heading}>
            <div className="vbn-iv-title">{props.data.Title}</div>
          </div>
          <div className="vbn-iv-learn-more-wrapper cpvi-grid-col w6" style={{ height: rightHeight }}>
            <div className="vbn-iv-learn-more-holder">
              <LearnMoreButton
                className="vbn-iv-learn-more"
                data={props.data.LearnMore}
              />
              <Arrow hideFromADA={true} direction="right" width={isMobileLayout ? "3px" : "4px"}/>
            </div>
          </div>
        </div>
      </div>
      <div className="cpvi-grid-container">
        <div className="cpvi-grid-row">
          <div className="cpvi-grid-col w12">
            <div className="vbn-iv-video-wrapper" ref={videoWrapperRef}>
            {
              props.data.Video
              &&
              <div className="vbn-iv-video" role="img" aria-label={props.data.Video.AltText}>
                <ReactPlayer
                  url={props.data.Video.URL}
                  width={videoDimensions.width}
                  height={videoDimensions.height}
                  muted={true}
                  loop={true}
                  playsinline={true}
                  playing={isPlaying}
                  volume={0}
                  controls={1}
                  config={{
                    youtube: props.data.Video.URL.indexOf("youtube.com") < 0 ? null : {
                      playerVars: {
                        autoplay: 1,
                        showinfo: 1,
                        playsinline:1
                      },
                      onUnstarted: () => loopVideo()
                    }
                  }}
                  onReady={ () => loopVideo() }
                  onStart={handleVideoStart}
                />
                {/* <div
                  className={`vbn-iv-video-blocker ${isPlaying && hasStarted ? '' : 'video-not-playing'}`}
                  style={{
                    backgroundColor: props.data.Video.Overlay || null,
                    opacity: props.data.Video.Opacity || 0
                  }}
                ></div> */}
              </div>
            }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default VbnVideo;
